export enum MessageType {
  CHATSCRIPT_ACTIVATE = 'chatscript-activate',
  CHATSCRIPT_DEACTIVATE = 'chatscript-deactivate',
  CREDIT_PENDING = 'conversation-credit-pending',
  EXPERT_START_TYPING = 'expert-start-typing',
  EXPERT_ENTERED_CHAT = 'conversation-expert-entered-chat',
  EXPERT_FINISH_TYPING = 'expert-finish-typing',
  CREDIT_ADDED = 'credit-added',
  JOIN = 'join',
  RESUME = 'conversation-resume-new',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  RESUME_CREDIT_ADDED = 'conversation-resume-new',
  LEAVE = 'leave',
  INFO = 'info',
  MESSAGE = 'message',
  PING = 'ping',
  PONG = 'pong',
  ONE_MINUTE_LEFT = 'conversation-one-minute-left',
  START = 'conversation-start',
  STOP = 'conversation-stop',
  CUSTOMER_HAS_BEEN_INACTIVE = 'customer-has-been-inactive',
}

export enum AuthorType {
  AI = 'ai',
  CHATSCRIPT = 'chatscript',
  CUSTOMER = 'customer',
  EXPERT = 'expert',
  SYSTEM = 'system',
}

export interface Message {
  '@id': string;
  author?: string;
  authorIdentifier?: string;
  authorType?: AuthorType;
  conversation: string;
  conversationBetween?: object;
  date: string;
  message: string;
  talismanUrl?: string;
  talismanId?: number;
  type: MessageType;
}

export interface MercureMessage {
  data: Message;
  id: string;
}
